import { apiServer, injectStore } from './axiosConfig';


/**
 * Lazy Loader Helper
 */
const createLazyService = (importFn, isNamed = false, namedKey = '') => {
  return new Proxy(
    {},
    {
      get: (target, prop) => {
        return async (...args) => {
          const module = await importFn();
          let ServiceFactory;

          if (isNamed && namedKey) {
            ServiceFactory = module[namedKey];
          } else {
            ServiceFactory = module.default || module;
          }

          const serviceInstance =
            typeof ServiceFactory === 'function'
              ? ServiceFactory(apiServer)
              : ServiceFactory;

          if (!serviceInstance[prop]) {
            throw new Error(`Method ${String(prop)} not found in service.`);
          }

          return serviceInstance[prop](...args);
        };
      },
    }
  ) as any; // Yahan 'as any' lagane se TS errors ruk jayenge
};

// --- Service Definitions ---

const userService: any = createLazyService(() => import('./UserService'));
const productService: any = createLazyService(() => import('./ProductService'));
const orderService: any = createLazyService(() => import('./OrderService'));
const categoryService: any = createLazyService(
  () => import('./CategoryService')
);
const reviewService: any = createLazyService(() => import('./ReviewService'));
const invoiceService: any = createLazyService(() => import('./InvoiceService'));
const subCategoryService: any = createLazyService(
  () => import('./SubCategoryService')
);
const customerService: any = createLazyService(
  () => import('./CustomerService')
);
const refundService: any = createLazyService(() => import('./RefundService'));
const bannerService: any = createLazyService(() => import('./BannerService'));
const communityService: any = createLazyService(
  () => import('./CommunityService')
);
const storyProductService: any = createLazyService(
  () => import('./StoryProductService')
);
const attributeService: any = createLazyService(
  () => import('./AttributeService')
);
const couponService: any = createLazyService(() => import('./CouponService'));
const wholesalerService: any = createLazyService(() => import('./Wholesaler'));
const logoService: any = createLazyService(() => import('./LogoServices'));
const pageService: any = createLazyService(() => import('./pageService'));
const domainService: any = createLazyService(() => import('./GeneralSetup'));
const themeService: any = createLazyService(() => import('./ThemeServices'));
const socialMediaService: any = createLazyService(
  () => import('./SocialMediaService')
);
const testimonialService: any = createLazyService(
  () => import('./TestimonialServices')
);
const paymentGatewayService: any = createLazyService(
  () => import('./PaymentGatewayServices')
);
const subscriptionPlan: any = createLazyService(
  () => import('./SubscriptionPlan')
);
const walletServices: any = createLazyService(() => import('./walletServices'));
const beneficaryServices: any = createLazyService(
  () => import('./beneficiaryService')
);
const businessCategory: any = createLazyService(
  () => import('./businessCategoryService')
);
const pluginService: any = createLazyService(() => import('./pluginServices'));
const liveSaleService: any = createLazyService(
  () => import('./LiveSaleService')
);
const featuredDealService: any = createLazyService(
  () => import('./FeatureSaleService')
);
const dealOfTheDayService: any = createLazyService(
  () => import('./DealoftheDayService')
);
const poService: any = createLazyService(() => import('./PoService'));
const PoListService: any = createLazyService(() => import('./PoListService'));
const addBillingService: any = createLazyService(
  () => import('./addBillingService')
);
const getBillingService: any = createLazyService(
  () => import('./getBillingListService')
);
const communityVideosService: any = createLazyService(
  () => import('./CommunityVideosService')
);
const addPurchaseOrderService: any = createLazyService(
  () => import('./AddPurchaseOrderdata')
);
const superAdminRecharged: any = createLazyService(
  () => import('./superAdminRecharged')
);
const proFormaInvoiceForm: any = createLazyService(
  () => import('./proFormaInvoice')
);
const productReportData: any = createLazyService(
  () => import('./productReportServices')
);
const orderReportDataList: any = createLazyService(
  () => import('./orderReportServic')
);
const saleReportDataList: any = createLazyService(
  () => import('./saleReportServic')
);
const addThemeService: any = createLazyService(
  () => import('./themeAddServices')
);
const themePurchaseFun: any = createLazyService(
  () => import('./themePurchaseFunction')
);
const adminThemeSale: any = createLazyService(() => import('./adminThemeSale'));
const userThemeList: any = createLazyService(
  () => import('./userThemeInstalledServices')
);
const deleteThemeService: any = createLazyService(
  () => import('./themeDeleteService')
);
const zipFileUploadProject: any = createLazyService(
  () => import('./ProjectUploadService')
);
const facebookAccountSetup: any = createLazyService(
  () => import('./facebookAccountSetupService')
);
const fbCampaignSetup: any = createLazyService(
  () => import('./fbCampaignService')
);
const fbAdsSetup: any = createLazyService(() => import('./facebookAdsService'));
const fbAdsetSetup: any = createLazyService(
  () => import('./facebookAdsetService')
);
const fbCreativeSetup: any = createLazyService(
  () => import('./facebookCreativeService')
);
const fbLeadsSetup: any = createLazyService(
  () => import('./facebookLeadsService')
);
const ticketSetup: any = createLazyService(
  () => import('./ticketService')
);
const crmSetup: any = createLazyService(
  () => import('./crmApiService')
);
const employeeKpiService: any = createLazyService(
  () => import('./employeeKpiService')
);
const verifywholesalerservice: any = createLazyService(
  () => import('./VerifyWholesalerService')
);
const commissionservice: any = createLazyService(
  () => import('./CommissionService')
);
const vendorsService: any = createLazyService(
  () => import('./vendorsServices')
);
const vendorProductsSlice: any = createLazyService(
  () => import('./VendorProduct')
);
const instagramAccountSetup: any = createLazyService(
  () => import('./instagramAccountSetupService')
);
const instagramCampaignSetup: any = createLazyService(
  () => import('./instagramCampaignService')
);
const instagramAdsetSetup: any = createLazyService(
  () => import('./instagramAdsetService')
);
const instagramCreativeSetup: any = createLazyService(
  () => import('./instagramCreativeService')
);
const instagramAdsSetup: any = createLazyService(
  () => import('./instagramAdsService')
);
const productSearchService: any = createLazyService(
  () => import('./productSearchService')
);
const vibemartTheme: any = createLazyService(() => import('./vibemartCtegory'));
const amountService: any = createLazyService(
  () => import('./amountLockServices')
);
const deliveryManService: any = createLazyService(
  () => import('./deliveryServices')
);
const adminBulkImport: any = createLazyService(
  () => import('./adminBulkImport')
);
const metaDataService: any = createLazyService(() => import('./metaServices'));
const resellerSubscriptionUrl: any = createLazyService(
  () => import('./resellerSubscription')
);
const employeesService: any = createLazyService(
  () => import('./employeeOrder')
);
const searchDomain: any = createLazyService(() => import('./vendorDomain'));
const calculateCharged: any = createLazyService(
  () => import('./calculateShipping')
);

// Named Exports
const brandService: any = createLazyService(
  () => import('./BrandService'),
  true,
  'BrandService'
);

const unitService: any = createLazyService(
  () => import('./UnitService'),
  true,
  'UnitService'
);

const enquiryService: any = createLazyService(
  () => import('./enquiryService')
);

const ApkBuild: any = createLazyService(() => import('./appBuild'));

// Shiprocket case
import shiprocketService from './shiprocketService';


const appListService: any = createLazyService(() => import('./appListService'));

const resellerService: any = createLazyService(
  () => import('./ResellerService')
);


// const loginWithWhatsAppService = ()=>import("./loginWithWhatsApp").then(m => m.default(apiServer));
const loginWithWhatsAppService: any = createLazyService(() => import('./loginWithWhatsApp'));


// const loginWithNumberService = () => import("./loginWithNumber").then(m => m.default(apiServer));
const loginWithNumberService: any = createLazyService(() => import('./loginWithNumber'));
const openAiResponseServices: any = createLazyService(() => import('./openAiResponseServices'));
const SubscriptionServices:any = createLazyService(()=> import('./subscriptiontUpgradeServices'))
const BlogData:any=createLazyService(()=>import('./blogServices'))
export {
  resellerService,
  injectStore,
  userService,
  productService,
  orderService,
  categoryService,
  reviewService,
  invoiceService,
  subCategoryService,
  customerService,
  refundService,
  bannerService,
  communityService,
  storyProductService,
  attributeService,
  couponService,
  wholesalerService,
  logoService,
  pageService,
  domainService,
  themeService,
  socialMediaService,
  brandService,
  unitService,
  testimonialService,
  paymentGatewayService,
  subscriptionPlan,
  walletServices,
  beneficaryServices,
  businessCategory,
  shiprocketService,
  pluginService,
  calculateCharged,
  liveSaleService,
  featuredDealService,
  dealOfTheDayService,
  poService,
  PoListService,
  addBillingService,
  getBillingService,
  communityVideosService,
  addPurchaseOrderService,
  superAdminRecharged,
  proFormaInvoiceForm,
  productReportData,
  orderReportDataList,
  saleReportDataList,
  addThemeService,
  themePurchaseFun,
  adminThemeSale,
  userThemeList,
  deleteThemeService,
  zipFileUploadProject,
  facebookAccountSetup,
  fbCampaignSetup,
  fbAdsSetup,
  fbAdsetSetup,
  fbCreativeSetup,
  fbLeadsSetup,
  crmSetup,
  verifywholesalerservice,
  commissionservice,
  vendorsService,
  vendorProductsSlice,
  instagramAccountSetup,
  instagramCampaignSetup,
  instagramAdsetSetup,
  instagramCreativeSetup,
  instagramAdsSetup,
  productSearchService,
  vibemartTheme,
  amountService,
  deliveryManService,
  adminBulkImport,
  metaDataService,
  resellerSubscriptionUrl,
  employeesService,
  searchDomain,
  ApkBuild,
  appListService,
  loginWithWhatsAppService,
    loginWithNumberService,
    openAiResponseServices,
    SubscriptionServices,
    BlogData,
     enquiryService,
     employeeKpiService,
     ticketSetup
};
